// extracted by mini-css-extract-plugin
export default {"wrap":"List_wrap__zyBOZ","tipWrap":"List_tipWrap__p-xpN","tipIcon":"List_tipIcon__AwJpo","text_error_color":"List_text_error_color__SH5-H"};